export default __webpack_public_path__ + "static/media/logo.4868b218.png";